module.exports = __webpack_public_path__ + "static/media/Cabinet_Scratch_After.8bb8b331.jpg";